module.exports = __webpack_public_path__ + "fonts/pb-icons.woff2";